import React, { Component } from 'react'
import classNames from 'classnames'
import moment from 'moment'

import './index.scss'
import OldMessageViewer from './OldMessageViewer'

import IconEmail from '../../../../assets/icon-email.svg'
import IconSMS from '../../../../assets/icon-sms.svg'

const getSentDate = date => moment.unix(date / 1000).format('DD MMM, HH:mm')

class BotMessage extends Component {
    constructor(props) {
        super(props)

        this.state = { OldMessageViewerOpened: false }
    }

    getMessage() {
        let { message } = this.props

        if (message) {
            message = message.trim()
        }

        return { __html: message }
    }

    showOldMessage() {
        if (this.props.oldMessage && !this.props.isConversation) {
            this.setState({ OldMessageViewerOpened: true })
        }
    }

    getAuthor() {
        return this.props.edited ? (
            'Dealer Representative'
        ) : (
            <span
                style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}
            >
                {this.props.botName}
                {this.props.channel === 'email' ? (
                    <>
                        <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='18'
                            height='18'
                            viewBox='0 0 18 18'
                        >
                            <g
                                id='Group_50'
                                data-name='Group 50'
                                transform='translate(-506 -469)'
                            >
                                <rect
                                    id='Rectangle_29'
                                    data-name='Rectangle 29'
                                    width='18'
                                    height='18'
                                    rx='2'
                                    transform='translate(506 469)'
                                    fill='#e09f50'
                                />
                                <text
                                    id='AI'
                                    transform='translate(515 482)'
                                    fill='#fff'
                                    fontSize='11'
                                    fontWeight='700'
                                >
                                    <tspan x='-5.28' y='0'>
                                        AI
                                    </tspan>
                                </text>
                            </g>
                        </svg>
                    </>
                ) : (
                    <>
                        <svg
                            xmlns='http://www.w3.org/2000/svg'
                            width='18'
                            height='18'
                            viewBox='0 0 18 18'
                        >
                            <g
                                id='Group_51'
                                data-name='Group 51'
                                transform='translate(-506 -469)'
                            >
                                <rect
                                    id='Rectangle_29'
                                    data-name='Rectangle 29'
                                    width='18'
                                    height='18'
                                    rx='2'
                                    transform='translate(506 469)'
                                    fill='#5d90d9'
                                />
                                <text
                                    id='AI'
                                    transform='translate(515 482)'
                                    fill='#fff'
                                    fontSize='11'
                                    fontWeight='700'
                                >
                                    <tspan x='-5.28' y='0'>
                                        AI
                                    </tspan>
                                </text>
                            </g>
                        </svg>
                    </>
                )}
            </span>
        )
    }

    render() {
        const {
            // user,
            sent,
            // followUp,
            // apptSet,
            ignoreUpdate,
            edited,
            // editedBy,
            HTOIgnore,
            channel,
        } = this.props
        const { OldMessageViewerOpened } = this.state
        const messageBlockClassnames = classNames({
            BotMessage__message__block: true,
            edited,
            ignoreUpdate,
            HTOIgnore,
            clickable: this.props.oldMessage && !this.props.isConversation,
            sms: channel === 'sms' && !ignoreUpdate,
        })

        const getAvatar = () => {
            if (channel === 'email') {
                return (
                    <div style={{ margin: 5, paddingTop: '24px' }}>
                        <img src={IconEmail} />
                        {/* <EmailIcon style={{ color: 'rgb(60, 184, 240)' }} /> */}
                    </div>
                )
            }
            if (channel === 'sms') {
                return (
                    <div style={{ margin: 5, paddingTop: '24px' }}>
                        <img src={IconSMS} />
                        {/* <PhoneAndroidIcon style={{ color: 'rgb(60, 184, 240)' }} /> */}
                    </div>
                )
            }
        }
        // const { status } = this.props

        // const statusToRender = status ? <p className='NeutralStatus'>Status: {status}</p> : false
        return (
            <div className='BotMessage'>
                <div className='BotMessage__message'>
                    <div>
                        <p className='BotMessage__sent-status'>
                            <span className={`author ${this.props.channel}`}>
                                {this.getAuthor()}
                            </span>
                            {ignoreUpdate ? (
                                <React.Fragment>
                                    Skipped on&nbsp;
                                </React.Fragment>
                            ) : (
                                <React.Fragment>Sent on&nbsp;</React.Fragment>
                            )}
                            {getSentDate(sent)}
                            {/* {statusToRender} */}
                            {/* {edited && ` by ${editedBy}`}
                            {followUp && ' <Follow Up>'}
                            {apptSet && ' <Appt Set>'} */}
                        </p>
                        <div
                            className={messageBlockClassnames}
                            onClick={() => this.showOldMessage()}
                        >
                            {/* <p> */}
                            <pre
                                dangerouslySetInnerHTML={this.getMessage()}
                            ></pre>
                            {/* </p> */}
                        </div>
                    </div>
                    {getAvatar()}
                    {/* <div className="BotMessage__message__avatar"></div> */}
                </div>
                {OldMessageViewerOpened && (
                    <OldMessageViewer
                        oldMessage={this.props.oldMessage}
                        OldMessageViewerClose={() => {
                            this.setState({ OldMessageViewerOpened: false })
                        }}
                    />
                )}
            </div>
        )
    }
}

export default BotMessage
